import { useRef, useState } from "react";

import useAxios from "@hooks/use-axios";
import { OPS_ENDPOINTS } from "@src/utility/constants/endpoints";

/**
 * The brand a previewed note is addressed to. The list row only carries the
 * brand's name, but the document also prints its GSTIN, address and contact,
 * so the full brand is fetched when a note is opened.
 */
const usePreviewBrand = () => {
    const { axiosInstance } = useAxios({ base: "ops", showAlert: false });
    const [brand, setBrand] = useState(null);
    // Guards against a slow response for a brand whose note has since been swapped.
    const requestRef = useRef(0);

    const loadBrand = async (note) => {
        const request = ++requestRef.current;
        // Show the name straight away; the rest fills in when the fetch lands.
        setBrand({ name: note.account_name });
        try {
            const res = await axiosInstance.get(OPS_ENDPOINTS.BRAND(note.account_id), { skipSessionRedirect: true });
            const result = res.data || res;
            const data = result.data || result;
            if (request === requestRef.current && data) setBrand({ name: note.account_name, ...data });
        } catch {
            // Keep the name-only fallback; the document shows "—" for the rest.
        }
    };

    return { brand, loadBrand };
};

export default usePreviewBrand;
